/**
 * TransportContainer.js
 * Styled Component for positioning the transport controls
 */
import styled from "styled-components";

// Styles
const TransportContainer = styled.div`
    display: flex;
    align-items: center;
`

export default TransportContainer